import BaseText from 'app/components/common/BaseText'
import { SectionBase } from 'app/components/common/SectionBase'
import { BaseTableManagement } from 'app/components/tables/BaseTableManagement'
import React from 'react'
import { useHook } from './hook'

export const EventInSevenDay: React.FC = () => {
  const { columns, data, isLoading, page, handleChangeTable, pageSize, total } =
    useHook()

  return (
    <SectionBase title="Danh sách sự kiện sắp diễn ra trong 7 ngày tới">
      <BaseTableManagement
        columns={columns}
        dataSource={data}
        loading={isLoading}
        pagination={{
          pageSize,
          current: page,
          total: total,
          showTotal: total => (
            <BaseText children={`Tổng: ${total}`} fontWeight="bold" />
          ),
          showSizeChanger: true,
        }}
        rowClassName="row-overwrite-style"
        onChange={handleChangeTable}
        scroll={{
          x: true,
          y: data?.length > 4 ? 300 : undefined,
        }}
      />
    </SectionBase>
  )
}
